import { styled } from "@mui/material/styles";
import { useControlledState } from "@react-stately/utils";

import { OnBookingSubmitProps } from "../..";
import { OnBookingCompletedCallback } from "../../../apiHooks";
import { ProductQuery } from "../../../apiHooks/graphql";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../../product/ProductBookNowButton";
import { BookingConsumerTripInput } from "../../../types/ProductFullLoaded";
import { AvailabilityExternalWidgetContent } from "../AvailabilityExternalWidgetContent";
import { AvailabilityModal } from "./AvailabilityModal";
import { InternalAvailabilityModalContent } from "./InternalAvailabilityModalContent";

export type InternalAvailabilityProps = {
    product: ProductQuery["product"];
    onBookingCompleted?: OnBookingCompletedCallback;
    bookingReference?: string;
    consumerTrip?: BookingConsumerTripInput;
    onAvailabilityChange?: (availability?: string | null) => void;
    open?: boolean;
    onContentClose?: (val: boolean) => void;
    submitButtonLabel?: string;
    onBookingSubmit?: (props: OnBookingSubmitProps) => Promise<void>;
};
export function AvailabilityContent({
    product,
    onBookingCompleted,
    bookingReference,
    consumerTrip,
    onAvailabilityChange,
    open,
    onContentClose,
    submitButtonLabel,
    onBookingSubmit,
}: InternalAvailabilityProps) {
    const [isModalOpen, setIsModalOpen] = useControlledState(!!open, false, (val: boolean) => onContentClose?.(val));
    const handleModalClose = () => setIsModalOpen(false);

    if (product.availabilityType === "EXTERNAL_WIDGET" && product.externalWidgetData) {
        const externalWidget = (
            <AvailabilityExternalWidgetContent
                widget={product.externalWidgetData}
                open={isModalOpen}
                onClose={handleModalClose}
            />
        );

        if (product.externalWidgetData.__typename === "ExternalWidgetRezdy") {
            return (
                <AvailabilityModal open={isModalOpen} onClose={handleModalClose}>
                    {externalWidget}
                </AvailabilityModal>
            );
        }

        return externalWidget;
    }

    return (
        <AvailabilityModal open={isModalOpen} onClose={handleModalClose}>
            <InternalAvailabilityModalContent
                product={product}
                bookingReference={bookingReference}
                onBookingCompleted={onBookingCompleted}
                onAvailabilityChange={onAvailabilityChange}
                BookingButtonComponent={BookNowButton}
                consumerTrip={consumerTrip}
                submitButtonLabel={submitButtonLabel}
                onBookingSubmit={onBookingSubmit}
            />
        </AvailabilityModal>
    );
}

const BookingButton = styled(ProductBookNowButton)(({ theme }) => ({
    borderRadius: theme.roundness,
})) as typeof ProductBookNowButton;

function BookNowButton(props: ProductBookNowButtonProps) {
    return <BookingButton data-leave-me-alone="true" {...props} />;
}
